<template>
  <LightBox :display="display" @close="handleClose">
    <template #header>
      <div class="absolute top-6 right-6 flex items-center gap-2">
        <BaseButton v-if="lightbox" :href="lightbox.src" type="custom">
          <FontAwesomeIcon :icon="['fas', 'external-link']" />
          <span>{{ $t('lightbox.open') }}</span>
        </BaseButton>

        <BaseButton type="secondary" @click="handleClose">
          {{ $t('lightbox.close') }}
        </BaseButton>
      </div>
    </template>
    <div v-if="lightbox" class="flex items-center justify-center">
      <vue-zoomer
        v-if="lightbox.type === 'img'"
        ref="zoomer"
        class="w-full h-full bg-white"
      >
        <img
          :src="lightbox.src"
          draggable="false"
          class="w-full h-full object-contain"
        />
      </vue-zoomer>
      <iframe
        v-else-if="lightbox.type === 'embed'"
        class="w-[90vw] h-full"
        :src="lightbox.src"
        frameborder="0"
        allowfullscreen="true"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      >
      </iframe>
    </div>
    <template #footer v-if="lightbox && lightbox.type === 'img'">
      <div class="absolute bottom-8 flex items-center gap-4">
        <BaseButton size="medium" icon @click="zoomOut" type="custom">
          <FontAwesomeIcon :icon="['fas', 'minus']" />
        </BaseButton>

        <BaseButton size="medium" icon @click="zoomIn" type="custom">
          <FontAwesomeIcon :icon="['fas', 'plus']" />
        </BaseButton>
      </div>
    </template>
  </LightBox>
</template>

<script setup lang="ts">
import VueZoomer from 'vue-zoomer/src/vue-zoomer.vue';
import LightBox from './LightBox.vue';

const configStore = useConfigStore();

const { lightbox } = storeToRefs(configStore);

const display = ref(false);

const handleClose = () => {
  configStore.setImageUrl(null);
};

onMounted(() => {
  configStore.setImageUrl(null);
});

watch(lightbox, (newVal) => {
  display.value = !!newVal;
});

// Zoomer
const zoomer = ref<any | null>(null);

const zoomIn = () => {
  zoomer.value?.zoomIn();
};

const zoomOut = () => {
  zoomer.value?.zoomOut();
};
</script>

<style scoped>
.test-enter-active,
.test-leave-active {
  display: flex;
}

.test-enter-from,
.test-leave-to {
  display: none;
}
</style>
